import { useContext } from "react";
import { EntityScoresContext } from "./context";

export const useEntityScoresOrUnavailable = () => {
    const context = useContext(EntityScoresContext);

    if (context) {
        return context;
    }

    throw new Error(`useEntityScoresOrUnavailable must be used within an EntityScoresProvider`);
};

export const useEntityScores = () => {
    const context = useEntityScoresOrUnavailable();

    if (context.isAvailable) {
        return context;
    }

    throw new Error(`useEntityScores requires available scores`);
};
